module.exports = __webpack_public_path__ + "media/assets/images/nexa@2x-ec9acdc44205f799ba73d80351ca9eef.png";